import { gql } from "graphql-request"

export default gql`
    query ($siteId: [QueryArgument]) {
        meeting: globalSet(handle: "meeting", siteId: $siteId) {
            siteId
            ... on meeting_GlobalSet {
                googleAdsNetworkId
                enableFacultyProfileLinks: reusableLightswitch
                sessionTypeTerm
            }
        }
        webviews: globalSet(handle: "webviews", siteId: $siteId) {
            ... on webviews_GlobalSet {
                moderatorRoles: string6
                moderatorRolesAdditional
                discussantRolesAdditional
                discussantRoles: string7
                backgroundColor: color1
                highlightColor: color2
                rooms {
                    id
                    ... on room_Entry {
                        label: string
                        roomIds
                        moderatorLayoutSize1
                        includeCountryFlags
                        backgroundImage {
                            url
                        }
                    }
                }
            }
        }
        theme: globalSet(handle: "theme", siteId: $siteId) {
            ... on theme_GlobalSet {
                colorPalette {
                    ... on colorPaletteBlock_Entry {
                        color1
                        color2
                        color3
                        color4
                        color5
                        color6
                        color7
                        color8
                        color9
                        color10
                        color11
                        color12
                        color13
                        color14
                        color15
                        color16
                    }
                }
            }
        }
    }
`
